import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import CompensationList from './List';
import CompensationCreate from './Create';
import CompensationDetail from './Detail';
import { injectIntl } from "react-intl";

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    Note: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    EarlyWarning: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = JSON.parse(JSON.stringify(defaultFields));
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;
    if (!clauses) {
        clauses = placeholdersQA.SupplierPropClauses.values.filter(item => item.isActive === true);
    }
    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Type = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
    fields.Type.clauses = clauses;

    fields.TaskOrder = { visible: true, label: "Task Order", required: false };
    fields.ProjectOrder = { visible: true, label: "Project Order", required: false };
    fields.Note = { visible: true, label: 'Edit notes through FieldsSupplierProp.Note', required: true };
    fields.Description = { visible: true, label: languageFile["GENERAL.FORMS.DESCRIPTION"], required: true };
    fields.EarlyWarning = { visible: true, label: "Early Warning", required: true };

    placeholdersQA.FieldsSupplierProp?.values?.forEach(fieldItem => {
        if (fields[fieldItem.field]) {
            fields[fieldItem.field].visible = fieldItem.isActive;
            fields[fieldItem.field].label = fieldItem.display;
        }
    });

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = JSON.parse(JSON.stringify(defaultReplyFields));

    var replyOptions = placeholdersQA.SupplierPropAcceptanceOptions.values
                .filter(item => item.isActive === true)
                .map(x => ({ value: Number(x.field), display: x.display }));



    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.REPLY_COMMENTS"], required: true };
    return replyFields;
}

class ProposedVariationRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<CompensationList
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <CompensationCreate
                                {...this.props}
                                mode={this.props.mode}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<CompensationDetail
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
            </Routes>
        );
    }
};



export default injectIntl(ProposedVariationRouter);